// Themes and concepts data — 5 themes x 5 concepts. Each concept has a name, image and vibe.
// Images from Unsplash (verified via design guidelines) — no logos, actual concept images.

export const THEMES = {
  baby_reveal: {
    id: "baby_reveal",
    name: "Baby Reveal",
    tagline: "Baby shower + revelación de sexo",
    description: "Un solo evento para celebrar la llegada y descubrir si es niña o niño.",
    accentColor: "#D9AEB0",
    heroCopy: "¿Niña o niño? Que la magia lo diga.",
    countdownLabel: "Nuestros corazones ya lo saben, pero lo sabremos juntos en...",
    icon: "baby",
    concepts: [
      { id: "boho_bear", name: "Osito Boho", image: "https://images.unsplash.com/photo-1659654155120-54c0b8e61406?w=1200&q=80", vibe: "Tonos crema, pampas y ositos de acuarela." },
      { id: "clouds_stars", name: "Nubes & Estrellas", image: "https://images.unsplash.com/photo-1738330943863-0f45d97e3455?w=1200&q=80", vibe: "Globos neutros con nubes suaves." },
      { id: "safari_baby", name: "Baby Safari", image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=1200&q=80", vibe: "Animalitos, hojas tropicales y tierra." },
      { id: "boho_pampas", name: "Pampas Neutro", image: "https://images.unsplash.com/photo-1635388134853-d5ae4f76902a?w=1200&q=80", vibe: "Arco de pampas, orquídeas y madera." },
      { id: "cloud_9", name: "Nube 9", image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1200&q=80", vibe: "Cielo pastel, minimalista y soñador." },
    ],
  },
  boda: {
    id: "boda",
    name: "Boda",
    tagline: "Sí, acepto",
    description: "Para el día más importante — tan clásico o boho como lo sueñas.",
    accentColor: "#C5A880",
    heroCopy: "Nuestro para siempre empieza aquí.",
    countdownLabel: "Faltan para el sí, acepto",
    icon: "heart",
    concepts: [
      { id: "candle_dinner", name: "Cena a la Luz", image: "https://images.unsplash.com/photo-1524777313293-86d2ab467344?w=1200&q=80", vibe: "Velas, flores y madera." },
      { id: "boho_arch", name: "Arco Boho", image: "https://images.unsplash.com/photo-1665607437981-973dcd6a22bb?w=1200&q=80", vibe: "Mesa larga con pampas y linos crudos." },
      { id: "romantic_florals", name: "Florales Románticos", image: "https://images.unsplash.com/photo-1641996250159-9d2bbfb483fa?w=1200&q=80", vibe: "Rosas, hortensias y vajilla dorada." },
      { id: "classic_formal", name: "Clásica Formal", image: "https://images.unsplash.com/photo-1649615644622-6d83f48e69c5?w=1200&q=80", vibe: "Cristalería, blanco impecable y oro." },
      { id: "garden_love", name: "Jardín Encantado", image: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=1200&q=80", vibe: "Verde exuberante y luces cálidas." },
    ],
  },
  xv_anos: {
    id: "xv_anos",
    name: "XV Años",
    tagline: "Una noche inolvidable",
    description: "De lo tradicional a lo trendy, tu quinceañera con carácter.",
    accentColor: "#D28E75",
    heroCopy: "Mis quince, mi noche, mi historia.",
    countdownLabel: "Faltan para mis XV",
    icon: "sparkles",
    concepts: [
      { id: "glam_party", name: "Glam Party", image: "https://images.unsplash.com/photo-1699730164892-d7c433524ff3?w=1200&q=80", vibe: "Champagne, oro y luces." },
      { id: "trendy_martini", name: "Trendy Martini", image: "https://images.unsplash.com/photo-1525373612132-b3e820b87cea?w=1200&q=80", vibe: "Bar retro, dusty rose y neón suave." },
      { id: "runway_neon", name: "Runway Neon", image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1200&q=80", vibe: "Pista iluminada y humo." },
      { id: "hollywood", name: "Old Hollywood", image: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1200&q=80", vibe: "Glamour vintage y candelabros." },
      { id: "confetti_dream", name: "Confetti Dream", image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=80", vibe: "Fuegos y celebración." },
    ],
  },
  cumpleanos: {
    id: "cumpleanos",
    name: "Cumpleaños",
    tagline: "Cumple mágico",
    description: "Cumples infantiles con temática, color y muchísimo cariño.",
    accentColor: "#9DB0A3",
    heroCopy: "Un año más para brillar.",
    countdownLabel: "Faltan para el cumple",
    icon: "cake",
    concepts: [
      { id: "confetti_kids", name: "Confetti Neutro", image: "https://images.unsplash.com/photo-1559456751-057ed03f3143?w=1200&q=80", vibe: "Colores tierra y confeti." },
      { id: "paper_cone", name: "Paper Cones", image: "https://images.unsplash.com/photo-1478145787956-f6f12c59624d?w=1200&q=80", vibe: "Gorritos, mesa dulce y vela." },
      { id: "balloon_arch", name: "Arco Globos", image: "https://images.unsplash.com/photo-1530103862676-de3c9de59f9e?w=1200&q=80", vibe: "Arco de globos color crema y camel." },
      { id: "circus_fun", name: "Fiesta Circus", image: "https://images.unsplash.com/photo-1513151233558-d860c5398176?w=1200&q=80", vibe: "Rayas, palomitas y diversión." },
      { id: "party_hats", name: "Party Hats Mini", image: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=1200&q=80", vibe: "Minimalista, dulce y elegante." },
    ],
  },
  bautizo: {
    id: "bautizo",
    name: "Bautizo",
    tagline: "Un día bendecido",
    description: "Un momento sagrado, celebrado con calma y luz.",
    accentColor: "#7A826B",
    heroCopy: "Bendecido para toda la vida.",
    countdownLabel: "Faltan para el bautizo",
    icon: "dove",
    concepts: [
      { id: "sacred_church", name: "Iglesia Blanca", image: "https://images.unsplash.com/photo-1504198458649-3128b932f49e?w=1200&q=80", vibe: "Arquitectura serena, luz natural." },
      { id: "white_petals", name: "Pétalos Blancos", image: "https://images.unsplash.com/photo-1438283173091-5dbf5c5a3206?w=1200&q=80", vibe: "Flores blancas y encaje." },
      { id: "angelic_light", name: "Luz Angelical", image: "https://images.unsplash.com/photo-1507643179773-3e975d7ac515?w=1200&q=80", vibe: "Suavidad, blancos y dorados." },
      { id: "linen_grace", name: "Lino & Gracia", image: "https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=1200&q=80", vibe: "Tejidos naturales y minimalismo." },
      { id: "candle_peace", name: "Vela de Paz", image: "https://images.unsplash.com/photo-1494959324546-995b0583cc95?w=1200&q=80", vibe: "Velas, oración y calma." },
    ],
  },
  otros: {
    id: "otros",
    name: "Otros",
    tagline: "Una celebración especial",
    description: "Reuniones, aniversarios, despedidas, graduaciones… cualquier evento con textos neutros.",
    accentColor: "#B08968",
    heroCopy: "Nos vemos para celebrar.",
    countdownLabel: "Faltan para el evento",
    icon: "sparkles",
    concepts: [
      { id: "mesa_larga", name: "Mesa Larga", image: "https://images.unsplash.com/photo-1536392706976-e486e2ba97af?w=1200&q=80", vibe: "Velas, flores y mesa compartida." },
      { id: "reunion_social", name: "Reunión Social", image: "https://images.unsplash.com/photo-1699730148132-1409a3728479?w=1200&q=80", vibe: "Amigos, copas y buena charla." },
      { id: "terraza_luces", name: "Terraza & Luces", image: "https://images.unsplash.com/photo-1630840274967-ece6eaa61dfc?w=1200&q=80", vibe: "Series de luces al aire libre." },
      { id: "brindis_flores", name: "Brindis & Flores", image: "https://images.unsplash.com/photo-1562050147-fda1cc9a6378?w=1200&q=80", vibe: "Flores blancas, velas y cristalería." },
      { id: "cena_intima", name: "Cena Íntima", image: "https://images.unsplash.com/photo-1562050344-f7ad946cee35?w=1200&q=80", vibe: "Mesa vestida de blanco, cálida y sobria." },
    ],
  },
};

export const THEME_LIST = Object.values(THEMES);

export const getTheme = (id) => THEMES[id] || null;
export const getConcept = (themeId, conceptId) => {
  const t = THEMES[themeId];
  if (!t) return null;
  return t.concepts.find((c) => c.id === conceptId) || null;
};

// Default dress code palettes per theme (starter)
export const DEFAULT_DRESSCODES = {
  baby_reveal: { style: "Boho Chic", note: "Tonos crema, camel y off-white. Comodidad primero.", colors: ["#F5F2EB", "#C5A880", "#D9AEB0", "#7A826B"] },
  boda: { style: "Formal Elegante", note: "Colores tierra, evita el blanco (¡ese día es de la novia!)", colors: ["#3E3A35", "#C5A880", "#D28E75", "#7A826B"] },
  xv_anos: { style: "Cocktail Glam", note: "Vestido largo o cocktail. Tacón alto obligatorio.", colors: ["#D28E75", "#C5A880", "#3E3A35", "#D9AEB0"] },
  cumpleanos: { style: "Casual Divertido", note: "Colores alegres, sin dress code estricto.", colors: ["#D9AEB0", "#9DB0A3", "#C5A880", "#F5F2EB"] },
  bautizo: { style: "Blanco & Neutros", note: "Colores claros, elegante y sereno.", colors: ["#FDFBF7", "#F5F2EB", "#C5A880", "#9DB0A3"] },
  otros: { style: "Casual Elegante", note: "Ven cómodo pero con estilo. Sin colores prohibidos.", colors: ["#F5F2EB", "#B08968", "#7A826B", "#3E3A35"] },
};
